module.exports = __webpack_public_path__ + "img/eject-fill.1517291a.svg";